import BellIcon from '../assets/logo/BellIcon';
import CustomButton from '../components-library/buttons/CustomButton';
import IllustrationExplainer from '../components-library/IllustrationExplainer';
import { SCREENS } from '../services/exports/Constants';
import { useTranslation } from 'react-i18next';
import useConfig from '../hooks/ui/useConfig';
import WindowResource from '../services/resources/WindowResource';

export default function ErrorScreen() {
  const { t } = useTranslation(null, { keyPrefix: 'Pages:ErrorScreen' });

  const { logo_url } = useConfig();

  const navigateHome = (): void => WindowResource.setHref(SCREENS.HOME_SCREEN);

  function renderHeader() {
    return (
      <header className={headerContainer}>
        {logo_url && <img src={logo_url} alt="Logo" className={companyLogo} />}
      </header>
    );
  }

  return (
    <>
      {renderHeader()}
      <main className={container} data-test="error-screen">
        <IllustrationExplainer
          illustration={<BellIcon className="h-20 w-20" />}
          title={t('header')}
          description={t('text')}
        />
        <div className={buttonContainer}>
          <CustomButton onClick={navigateHome} title={t('button')} />
        </div>
      </main>
    </>
  );
}
const container = 'fixed inset-0 flex flex-col h-full w-full justify-center items-center lg:w-1/2 w-full mx-auto px-md';

const headerContainer = 'border-b flex flex-row justify-center py-xs';

const companyLogo = 'h-12';

const buttonContainer = 'lg:mt-xl mt-lg';
